// Utility function to get full file path
export const getFullFilePath = (pathName, fileName) => {
    return pathName.length !== 0 && fileName !== undefined
        ? `${pathName}/${fileName}`
        : fileName;
}